import {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {Icon, IconButton, makeStyles, Tooltip} from "@material-ui/core";
import {useSelector} from "react-redux";
import {Droppable, DragDropContext} from "react-beautiful-dnd";

import request from "../../../../../Services/API/Requests";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import SelectType from "../../../../../Utils/Form/FormDynamic/Fields/SelectType/Select";

import RestrictionItem from "./RestrictionItem";

const useStyles = makeStyles(() => ({
    container: {},
    paper: {
        marginTop: 5,
    },
    createNewContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: 'center'
    },
    title: {
        padding: 5,
        borderBottom: '1px solid rgba(0,0,0,0.1)',
    },
    selectTemplateContainer: {
        padding: 5,
    },
    restrictionItem: {
        padding: 3
    }
}))
const Restrictions = (props) => {
    const classes = useStyles();
    const {
        component: {properties = {}, styles: sourceStyles} = {},
        screenName,
        setValue,
        addGroup,
        removeGroup
    } = props;
    const globalValues = useSelector(state => state.jsonScreen.globalValues)
    const [restrictions, setRestrictions] = useState(false);
    const [values, setValues] = useState([]);

    const [isCreating, setIsCreating] = useState(false);
    const value = findByString(globalValues.param[screenName], properties.dataSource) || [];
    const styles = sourceStyles ? sourceStyles[0] : {};

    useEffect(() => {
        //if found empty object, creating state is active
        getRestrictions()
    }, [value.length]);

    useEffect(() => {
        const findEmptyObj = value.find(v => Object.keys(v).length === 0) !== undefined;
        setIsCreating(findEmptyObj)
        setValues(value)
    }, [JSON.stringify(value)])

    async function getRestrictions() {
        try {
            if (!properties.entity) return;
            const restrictions = await request({
                url: "/list/getData",
                data: {
                    id: "restrictionDefaultList",
                    advancedFilter: [
                        {field: 'forEntity.id', operand: "equal", value: properties.entity}
                    ]
                }
            })
            if (restrictions.content && restrictions.content.length > 0) {
                //filter by existing template and filter by selected value
                setRestrictions(
                    restrictions.content
                        .filter(v => v.template)
                        .filter(v => !(value.map(v => v.id).includes(v.id)))
                        .map(v => {
                            return {value: v.id, label: v.name}
                        }));
            }
        } catch (e) {
            console.error(e);
            return null
        }
    }

    function onDragEnd(result) {
        const reorder = (list, startIndex, endIndex) => {
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);
            return result;

        };
        const reordered = reorder(values, result.source.index, result.destination.index);
        setValues(reordered)
        setValue(reordered, properties.dataSource)
    }

    function onBlur(v, p) {
        if (!v) {
            const path = p.split('.').slice(0, -1).join('.')
            removeGroup(path)
            return
        }
        setValue(v, p)
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <div style={{...styles}}>
                {(!values || !values.length) && (
                    <div className={classes.createNewContainer}>
                        <Tooltip title={'Create new restriction'}>
                            <IconButton
                                size="small"
                                disabled={props.designMode}
                                style={{marginTop: 5}}
                                onClick={() => {
                                    setValue({}, `${properties.dataSource}.0`)
                                }}>
                                <Icon fontSize={"small"}>
                                    add
                                </Icon>
                            </IconButton>
                        </Tooltip>
                    </div>
                )}
                <Droppable droppableId={'restrictions'}>
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            tabIndex={-1}
                        >
                            {values && values.map((restriction, index) => {
                                if (restriction.id) {
                                    return (
                                        <div key={restriction.id} tabIndex={-1}>
                                            <RestrictionItem restriction={restriction}
                                                             index={index}
                                                             sourcePath={`${properties.dataSource}`}
                                                             addGroup={addGroup}
                                                             removeGroup={removeGroup}
                                                             isCreating={isCreating}
                                            />
                                        </div>
                                    )
                                }
                                return (
                                    <div className={classes.selectTemplateContainer} key={index}>
                                        <SelectType
                                            field={{
                                                type: "objSelect",
                                                values: restrictions,
                                                path: `${properties.dataSource}.${index}.id`,
                                                placeholder: "Select template",
                                                autofocus: isCreating,
                                            }}
                                            onBlur={onBlur}
                                            setValue={setValue}
                                            fieldStyles={{
                                                fullWidth: true,
                                            }}
                                        />
                                    </div>
                                )
                            })}
                            {provided.placeholder}
                        </div>
                    )}

                </Droppable>
            </div>
        </DragDropContext>
    )
}
export default JsonScreenHoc(Restrictions);

Restrictions.propTypes = {
    designMode: PropTypes.bool,
    component: PropTypes.shape({
        properties: PropTypes.shape({
            entity: PropTypes.string,
            dataSource: PropTypes.string
        }),
        styles: PropTypes.any,
        events: PropTypes.any
    }),
}